import Webcam from "./Webcam";

export * from "./Antenna";
export * from "./AudioLine";
export * from "./AudioWaveform";
export * from "./BookHeart";
export * from "./Camera";
export * from "./CameraOff";
export * from "./CassetteTape";
export * from "./Cctv";
export * from "./ChevronsLeftRightEllipsis";
export * from "./CircleFadingPlus";
export * from "./EathernetPort";
export * from "./Lectern";
export * from "./Mic";
export * from "./MicOff";
export * from "./Newspaper";
export * from "./Nfc";
export * from "./Notebook";
export * from "./Phone";
export * from "./PhoneCall";
export * from "./PhoneMissed";
export * from "./PhoneOff";
export * from "./Presentation";
export * from "./Projector";
export * from "./Radar";
export * from "./ScreenShare";
export * from "./ScreenShareOff";
export * from "./Send";
export * from "./SendHorizontal";
export * from "./SmartphoneNfc";
export * from "./SmilePlus";
export * from "./Sticker";
export * from "./StickyNote";
export * from "./SwitchCamera";
export * from "./Tv";
export * from "./Video";
export * from "./VideoOff";
export * from "./Videotape";
export * from "./Volume";
export * from "./Volume1";
export * from "./Volume2";
export * from "./VolumeX";
export * from "./VolumeOff";
export * from "./Webcam";

export const Communi = {
  Webcam,
};
